// extracted by mini-css-extract-plugin
export default {"div_data":"NotFound_div_data__C6gml"};